import React from 'react';

import { useTranslation } from 'react-i18next';

import { useProcessingOverlay } from '../context/ProcessingOverlayContext';
import '../styles/GlobalProcessingOverlay.css';

const GlobalProcessingOverlay: React.FC = () => {
  const { t } = useTranslation('common');
  const { isVisible, activeProcesses } = useProcessingOverlay();

  if (!isVisible) {
    return null;
  }

  return (
    <div className="global-processing-overlay" role="status" aria-live="polite">
      <div className="global-processing-panel">
        <div className="global-processing-header">
          <span className="global-processing-title">
            {t('processingOverlay.title', 'Ongoing processes')}
          </span>
        </div>
        <div className="global-processing-list">
          {activeProcesses.map((p) => (
            <div
              key={p.id}
              className={`global-processing-item type-${p.type}`}
              title={p.sublabel || p.label}
            >
              <div className="global-processing-spinner" aria-hidden="true" />
              <div className="global-processing-texts">
                <span className="global-processing-label">
                  {p.type === 'upload'
                    ? t('processingOverlay.uploadingFile', 'Uploading file')
                    : p.type === 'generate'
                      ? t('processingOverlay.generatingReport', 'Generating report')
                      : p.label || t('processingOverlay.processing', 'Processing')}
                  <span className="dots" />
                </span>
                {p.sublabel && <span className="global-processing-sublabel">{p.sublabel}</span>}
                {typeof p.progress === 'number' && (
                  <div className="global-processing-progress" aria-hidden="true">
                    <div
                      className="global-processing-progress-bar"
                      style={{ width: `${Math.min(Math.max(p.progress, 0), 100)}%` }}
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export { GlobalProcessingOverlay };
